import React from 'react';
import { motion } from 'framer-motion';
import { LiveBadge } from './LiveBadge';
import { PlayIcon, ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-60">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-grid opacity-50" data-id="element-61" />
      <div className="absolute inset-0 scanlines" data-id="element-62" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-stream-600/20 rounded-full blur-[120px] pointer-events-none" data-id="element-63" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-65">
          <LiveBadge className="mb-8" data-id="element-66" />

          <div className="monitor-frame monitor-frame-br p-8 md:p-12 glass-panel rounded-xl mb-8 relative" data-id="element-67">
            <div className="absolute top-4 left-4 flex gap-1.5" data-id="element-68">
              <div className="w-2 h-2 rounded-full bg-white/20" data-id="element-69" />
              <div className="w-2 h-2 rounded-full bg-white/20" data-id="element-70" />
              <div className="w-2 h-2 rounded-full bg-white/20" data-id="element-71" />
            </div>

            <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-white mb-6 mt-4" data-id="element-72">
              Turn Your Stream Into a <br className="hidden md:block" data-id="element-73" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-stream-400 to-stream-600" data-id="element-74">
                Revenue Engine
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto font-light" data-id="element-75">
              We transform hobbyist channels into profitable media brands. Stop
              guessing with the algorithm and start building a sustainable
              broadcast business.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-76">
            <button className="w-full sm:w-auto px-8 py-4 bg-stream-600 hover:bg-stream-500 text-white font-semibold rounded-lg transition-all flex items-center justify-center gap-2 group shadow-[0_0_20px_rgba(168,85,247,0.4)]" data-id="element-77">
              Book a Strategy Call
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-78" />
            </button>
            <button className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white/10 hover:border-white/30 hover:bg-white/5 text-white font-semibold rounded-lg transition-all flex items-center justify-center gap-2" data-id="element-79">
              <PlayIcon className="w-4 h-4" data-id="element-80" />
              See Our Results
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}